module.exports = __webpack_public_path__ + "img/all_hi.2c24dca0.jpg";